import { FantasyPosition } from '@pff-consumer/schema'

export const isDefensePosition = (position?: string) => FantasyPosition.DEF === position
